const ShotMass=[
    {
        id:1,
        title:"Jägermeister (Німеччина) 1л",
        price:"2400 грн",
        src: require('../img/jager.webp'),
        text:"50мл - 120 грн",
    },
    {
        id:2,
        title:"Jägermeister (Німеччина) 0,5л",
        price:"1300 грн",
        src: require('../img/jager.webp'),
        text:"",
    },
    {
        id:4,
        title:"Jägermeister orange (Німеччина) 1л",
        price:"3400 грн",
        src: require('../img/Jägermeisterorange.png'),
        text:"50мл - 170 грн",
    },
    // {
    //     id:3,
    //     title:"акція Єгермайстер 1+1",
    //     price:"150 грн",
    //     src: require('../img/jager.webp'),
    //     text:"",
    // },
    
]

export default ShotMass;